import CanvasDispatch from './canvas.dispatch';
import EditorDispatch from './editor.dispatch';
import ElementDispatch from './element.dispatch';

export function configureDispatchers () {
  CanvasDispatch.configureDispatchers(INKIVE);
  EditorDispatch.configureDispatchers(INKIVE);
  ElementDispatch.configureDispatchers(INKIVE);
}

export function addProjectFacadeListeners (ProjectFacade) {
  EditorDispatch.addProjectFacadeListeners(ProjectFacade);
}
